import { Scissors, Clock, User, Calendar } from 'lucide-react';
import { clsx } from 'clsx';
import { useState } from 'react';
import { Badge, Button } from '../ui';
import { formatLocalDateDisplay } from '../../utilities/dateUtils';

function InfoRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <Icon size={14} className="shrink-0 text-text-muted" aria-hidden="true" />
      <span className="text-text-muted">{label}:</span>
      <span className="text-text-primary font-medium">{value}</span>
    </div>
  );
}

export default function AppointmentCard({ appointment, onCancel, canCancel }) {
  const [cancelling, setCancelling] = useState(false);

  const handleCancel = async (e) => {
    setCancelling(true);
    try {
      await onCancel(e, appointment);
    } finally {
      setCancelling(false);
    }
  };

  return (
    <div className={clsx(
      'bg-surface border rounded-lg p-4 flex flex-col gap-3 transition-colors duration-normal',
      canCancel ? 'border-border' : 'border-border opacity-80',
    )}>
      {/* Header */}
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-primary-subtle flex items-center justify-center shrink-0">
            <Scissors size={14} className="text-primary" aria-hidden="true" />
          </span>
          <span className="text-sm font-semibold text-text-primary">{appointment.service}</span>
        </div>
        <Badge variant={canCancel ? 'success' : 'neutral'}>
          {canCancel ? 'Confirmado' : 'Concluído'}
        </Badge>
      </div>

      {/* Detalhes */}
      <div className="flex flex-col gap-1.5 pl-10">
        <InfoRow icon={User} label="Barbeiro" value={appointment.professional} />
        <InfoRow icon={Calendar} label="Data" value={formatLocalDateDisplay(appointment.date)} />
        <InfoRow icon={Clock} label="Horário" value={appointment.hour?.[0]} />
      </div>

      {/* Ação */}
      {canCancel && (
        <div className="pl-10 pt-1">
          <Button
            variant="danger"
            size="sm"
            loading={cancelling}
            onClick={handleCancel}
          >
            Cancelar agendamento
          </Button>
        </div>
      )}
    </div>
  );
}
